import gql from 'graphql-tag';

export const personFragment = gql`
  fragment personFragment on Person {
    email
    firstName
    lastName
    llmSummary
  }
`;
export default personFragment;
